import React from 'react';
import { LockIcon, ZapIcon, ArrowRightIcon } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="bg-slate-900 text-white py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-147">
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full max-w-2xl h-64 bg-amber-500/10 blur-[120px] rounded-full pointer-events-none" data-id="element-148"></div>

      <div className="max-w-xl mx-auto text-center relative z-10" data-id="element-149">
        <div className="bg-gradient-to-b from-slate-800 to-slate-800/80 border-2 border-amber-500 rounded-2xl px-6 py-8 md:px-10 md:py-10 shadow-[0_0_40px_rgba(245,158,11,0.15)] relative" data-id="element-150">
          <div className="absolute -top-4 left-1/2 -translate-x-1/2 bg-amber-500 text-slate-900 font-bold px-5 py-1.5 rounded-full text-xs uppercase tracking-wider flex items-center shadow-lg animate-pulse" data-id="element-151">
            <ZapIcon className="w-3.5 h-3.5 mr-1.5" data-id="element-152" />
            Oferta de Lanzamiento
          </div>

          <p className="text-amber-400/80 text-sm font-medium mb-2 mt-2 uppercase tracking-wide" data-id="element-153">
            Consigue "El Método del Sobre Digital"
          </p>

          <div className="flex justify-center items-baseline mb-1" data-id="element-154">
            <span className="text-5xl font-extrabold text-white" data-id="element-155">$6,39</span>
            <span className="text-xl text-slate-400 ml-2" data-id="element-156">USD</span>
          </div>
          <p className="text-slate-500 text-xs mb-5" data-id="element-157">
            Precio único de lanzamiento
          </p>

          <a href="https://pay.hotmart.com/A105110643F" target="_blank" rel="noopener noreferrer" className="w-full sm:w-auto inline-flex items-center justify-center px-5 py-3 text-sm font-bold text-slate-900 bg-amber-500 hover:bg-amber-400 rounded-full transition-all duration-200 shadow-[0_0_20px_rgba(245,158,11,0.3)] hover:shadow-[0_0_30px_rgba(245,158,11,0.5)] hover:-translate-y-0.5 mb-4 no-underline" data-id="element-158">
            QUIERO RECUPERAR EL CONTROL
            <ArrowRightIcon className="ml-2 w-3.5 h-3.5" data-id="element-159" />
          </a>

          <div className="flex items-center justify-center text-slate-500 text-xs" data-id="element-160">
            <LockIcon className="w-3.5 h-3.5 mr-1.5" data-id="element-161" />
            <span data-id="element-162">Acceso inmediato • Pago seguro y cifrado</span>
          </div>
        </div>
      </div>
    </section>;
}